<template>
	<div class="driverTableWrap">
		<v-data-table
				class="driverTable"
				:headers="headers"
				:page.sync="page"
				:items="items"
				:sort-by.sync="sortBy"
				:sort-desc.sync="sortDesc"
				:items-per-page="getItemsPerPage"
				@page-count="pageCount = $event"
				hide-default-footer
				hide-default-header
				hide-default-body
				fixed-header
		>
			<template v-slot:header="{ props: { headers } }">
				<thead>
				<tr>
					<th>
						<field
								margin="0"
								padding="0"
								height="24"
								:switch-value="checkAll"
								:indeterminate="indeterminate"
								@updateSwitch="onCheckboxAll"
								is-dense
								is-checkbox
								is-off-style
								:is-disabled="!listItems.length"
						></field>
					</th>
					<th
							v-for="(item, index) in headers"
							:class="[{'filter-active': filterClasses[item.valueFilter]},
                                {'dense': item.dense}]"
							:key="index"
							class=""
							:id="'container-'+item.value"
					>
						<div class="filterIcons">
							<sort-btn
									v-if="item.sortable"
									:sortDesc="sortDesc"
									:sortBy="sortBy"
									:data-sort="item.value"
									@updateToggleOrder="toggleOrder"
							></sort-btn>
							<span
									class="headText wh_w"
									:class="{ 'headText_sorted': getSortColor(sortBy, item.value), 'center': item.align }"
							>
                  {{ item.text }}
              </span>
						</div>
					</th>
				</tr>
				</thead>
			</template>
			<template v-slot:body="{ items }">
				<tbody>
				<template v-for="(item, idx) in items">
					<table-tr
							:item="item"
							:key="item.id"
							:idx="idx"
							:valid="valid"
							:checkClasses="checkClasses"
							:checkAll="checkAll"
							@updateCheckOrder="onCheckOrder"
					></table-tr>
				</template>
				<tr class="tableBottom">
					<td>n: <span>{{ listItems.length }}</span></td>
					<td :key="i" v-for="i in 3"></td>
				</tr>
				</tbody>
			</template>
		</v-data-table>
		<pagination
				v-if="items && items.length"
				:length="items.length"
				:pageCount="pageCount"
				:itemsPerPage="itemsPerPage"
				:page="page"
				:pages="pages"
				@updatePagination="onPagination"
				@updateCountPagination="onCountPagination"
		></pagination>
	</div>
</template>

<script>
// components
import TableTr from "@/components/Accounting/DriverStatements/DriverTable/TableTr/TableTr";
// shared
import Pagination from "@/shared/Pagination/Pagination";
import SortBtn from "@/shared/SortBtn/SortBtn";
// constants
import defaultHeader from "@/components/Statistics/DispatchStatistics/DispatchreportsTable/defaultHeader";

export default {
	name: "DispatchReportsTable",
	components: {
		TableTr,
		Pagination,
		SortBtn
	},
	props: {
		listItems: Array,
		valid: Object,
		checkAll: Boolean,
		indeterminate: Boolean
	},
	computed: {
		headers() {
			return defaultHeader;
		},
		getItemsPerPage() {
			return this.itemsPerPage === 'All' ? 99999999 : this.itemsPerPage;
		},
		items: {
			get() {
				return this.list;
			},
			set(arr) {
				this.list = arr;
			},
		},
		filterClasses: {
			get() {
				return this.checkClasses;
			},
			set(arr) {
				const obj = {};
				for (const i in arr) {
					obj[i] = arr[i].length;
				}
				this.checkClasses = obj;
			},
		},
	},
	watch: {
		listItems(val) {
			this.items = val;
		}
	},
	data() {
		return {
			pages: [ 10, 20, 50, 100, 200, 500 ],
			itemsPerPage: 10,
			page: 1,
			pageCount: 0,
			filterUpdate: false,
			sortBy: "id",
			sortDesc: true,
			menu: false,
			filtersMarker: {},
			filters: {},
			filtersList: {},
			list: this.listItems,
			checkClasses: {},
			filterPreloader: false,
			isRefreshPage: '',
			uniqId: { key: '', id: '' },
			isVisibleItems: false,
		};
	},
	methods: {
		onPagination(value) {
			this.page = value;
		},
		onCountPagination(value) {
			this.itemsPerPage = value;
		},
		getSortColor(sortBy, value) {
			return sortBy === value || (sortBy && value.includes(sortBy));
		},
		toggleOrder(val) {
			const { value } = this.headers.find(item => item.value === val);
			this.sortBy = value;
			this.sortDesc = !this.sortDesc;
		},
		onCheckOrder(item) {
			this.$emit('updateCheckOrder', item);
		},
		onCheckboxAll({ value }) {
			this.$emit('updateCheckOrders', value);
		}
	}
};
</script>

<style scoped lang="scss">
@import "dispatchReportsTable";
</style>

<style>
.driverTable .v-data-table__wrapper {
    max-height: 478px;
}
</style>

